import { dateRangePickerIntlIds } from './date-range-picker.ids';

export const dateRangePickerLangEnUs = {
  [dateRangePickerIntlIds.selectPeriodOrDateInput.placeholder]:
    'Select a period or date',
  [dateRangePickerIntlIds.goBackToTodayButton.label]: 'Today',
  [dateRangePickerIntlIds.clearSelectedPeriodButton.label]: 'Clear selection',
  [dateRangePickerIntlIds.cancelButton.label]: 'Cancel',
  [dateRangePickerIntlIds.selectPeriodButton.label]: 'Select',
  [dateRangePickerIntlIds.previousMonthAria.label]: 'Previous month',
  [dateRangePickerIntlIds.nextMonthAria.label]: 'Next month',
};
